<template>
  <div class="container">
    <img src="static/img/fylyb.png" style="width: 100%" alt="" />
    <van-cell-group style="margin-bottom: 60px">
      <van-field label="姓名" v-model="name" placeholder="请输入姓名" />
      <van-field
        label="联系方式"
        v-model="mobile"
        placeholder="请输入联系方式"
        type="tel"
      />
      <van-field
        label="所在镇街"
        v-model="jiedao"
        @click="jiedaoshowPicker = true"
        readonly
        clickable
        right-icon="arrow"
      />
      <van-field
        label="所在社区"
        v-model="shequ"
        @click="beforeshequchoose()"
        readonly
        clickable
        right-icon="arrow"
      />
      <van-field label="留言内容" readonly />
      <div style="margin: 0 16px">
        <van-field
          style="background: #f2f2f2; border-radius: 10px"
          rows="5"
          autosize
          type="textarea"
          placeholder="请输入咨询内容"
          v-model="content"
        />
      </div>
    </van-cell-group>
    <table></table>
    <div class="bottom">
      <div class="bt" @click="submit()">提交</div>
    </div>
    <van-popup v-model="jiedaoshowPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="list1"
        value-key="name"
        @cancel="jiedaoshowPicker = false"
        @confirm="jiedaoonConfirm"
      />
    </van-popup>
    <van-popup v-model="shequshowPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="list2"
        value-key="name"
        @cancel="shequshowPicker = false"
        @confirm="shequonConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import { Dialog } from "vant";
export default {
  name: "fylyb",
  data() {
    return {
      list1: [],
      list2: [],
      jiedaoshowPicker: false,
      jiedaochoose: "",
      jiedao: "",
      shequshowPicker: false,
      shequchoose: "",
      shequ: "",
      name: "",
      mobile: "",
      content: "",
    };
  },
  created() {
    this.locate();
  },
  methods: {
    locate() {
      this.$axios({
        method: "post",
        url: "/api/common/area",
        data: this.qs.stringify({
          code: "320281",
        }),
      }).then((res) => {
        if (res.data.code == 0) {
          this.list1 = res.data.data;
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
    tochoose(locate) {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
      this.$axios({
        method: "post",
        url: "/api/common/area",
        data: this.qs.stringify({
          code: locate,
        }),
      }).then((res) => {
        this.$toast.clear();
        if (res.data.code == 0) {
          this.list2 = res.data.data;
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
    jiedaoonConfirm(value, index) {
      this.jiedao = value.name;
      this.jiedaochoose = value.code;
      this.shequchoose = "";
      this.shequ = "";
      this.jiedaoshowPicker = false;
      this.tochoose(value.code);
    },
    shequonConfirm(value, index) {
      this.shequ = value.name;
      this.shequchoose = value.code;
      this.shequshowPicker = false;
    },
    beforeshequchoose() {
      if (this.jiedaochoose == "") {
        this.$toast("请先选择所在镇街");
        return;
      } else {
        this.shequshowPicker = true;
      }
    },
    submit() {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
      if (this.name == "") {
        this.$toast("请输入姓名");
        return;
      }
      if (this.mobile == "") {
        this.$toast("请输入手机号");
        return;
      } else if (this.mobile.length != 11) {
        this.$toast("请检查手机号是否填写正确");
        return;
      }
      if (this.jiedaochoose == "") {
        this.$toast("请选择所在镇街");
        return;
      }
      if (this.shequchoose == "") {
        this.$toast("请选择所在社区");
        return;
      }
      if (this.content == "") {
        this.$toast("请填写咨询内容");
        return;
      }
      this.$axios({
        method: "post",
        url: "/api/message_board/add",
        data: this.qs.stringify({
          name: this.name,
          mobile: this.mobile,
          street: this.jiedao,
          village: this.shequ,
          street_code: this.jiedaochoose,
          village_code: this.shequchoose,
          content: this.content,
        }),
      }).then((res) => {
        this.$toast.clear();
        if (res.data.code == 0) {
          Dialog.alert({
            message: "提交成功",
          }).then(() => {
            // on close
            this.jiedaochoose = "";
            this.jiedao = "";
            this.shequchoose = "";
            this.shequ = "";
            this.content = "";
          });
        } else {
          Dialog.alert({
            message: res.data.msg,
          }).then(() => {
            // on close
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  box-shadow: 0px -4px 16px 2px rgba(0, 0, 0, 0.08);
}
.bt {
  width: 80%;
  background: #c4b590;
  color: white;
  text-align: center;
  line-height: 40px;
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/fylyb.vue